import { colors, typography } from '@insurancemenu/imenu-components-lib';
import { Add } from '@insurancemenu/imenu-components-lib/dist/icons';
import styled from 'styled-components';

const ALPHA_BACKGROUND_COLOR = '99'; // 60%

export const SectionStyled = styled.div<{ $show: boolean }>`
  background-color: ${colors.blue[100]}${ALPHA_BACKGROUND_COLOR};
  margin: 4rem 0;
  border-radius: 10px;
  border: 1px solid ${colors.blue[200]};
  padding-bottom: ${({ $show }): string => ($show ? '1.5rem' : '0')};
`;

export const PreviewStyled = styled.div`
  display: flex;
  gap: 2rem;
  justify-content: space-between;
  cursor: pointer;

  /* Extra left padding aligns the icon container with the other components in the modal. */
  padding: 2rem 2rem 2rem 3rem;
`;

export const AddIconStyled = styled(Add)`
  width: 4rem;
  height: 4rem;
  padding: 0.6rem;
  background-color: ${colors.blue[200]}${ALPHA_BACKGROUND_COLOR};
  color: ${colors.blue[600]};
  border-radius: 10px;
  flex: 0 0 4rem;
`;

export const TextWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  text-align: left;
  flex: 2;
`;

export const TitleStyled = styled.h4`
  ${typography.bold[20]}
  color: ${colors.neutral[700]};
  margin: 0;
`;

export const SubtitleStyled = styled.h3`
  ${typography.regular[16]}
  color: ${colors.neutral[700]};
  margin: 0;
`;

export const ContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  text-align: left;
  border-top: 1px solid ${colors.neutral[300]};
  margin: 0.4rem 3rem 0;
  padding-top: 2.4rem;
`;
